import { Injectable } from '@angular/core';

import { setInitialStoreState } from '../../../../../common/utils';
import { UserDeletionHistoryFacade } from './user-deletion-history.facade';

@Injectable({
  providedIn: 'root',
})
export class UserDeletionHistoryGuard  {
  constructor(private userDeletionHistoryFacade: UserDeletionHistoryFacade) {}

  canDeactivate(): boolean {
    return setInitialStoreState(this.userDeletionHistoryFacade);
  }
}
